import React from 'react';
import {t} from '@lingui/core/macro';

import {PaymentCancel, PaymentResultScreen} from 'features/payment';

const PaymentCancelPage: React.FC = () => {
    return <PaymentResultScreen pageTitle={t`Отмена платежа`} Content={PaymentCancel}/>;
};

export default PaymentCancelPage;
